import styled from 'styled-components'
import { ContentHeader } from '../App'
import Item from './Confirmation/Item'
import Select from './Form/Select'
import Heading from './Heading'
import { useContext, useEffect, useRef, useState } from 'react'
import Textarea from './Form/Textarea'
import { OrderItemsContext } from '../context/OrderItemsContext'
import { ReservationContext } from '../context/ReservationContext'
import { OrderDataContext } from '../context/OrderDataContext'
import { ErrorContext } from "../context/ErrorContext";
import { MenuContext } from "../context/MenuContext";
import { TranslationContext } from '../context/TranslationContext'
import Api from "../api/api";

function ConfirmPage ({ page }) {
    const myRef = useRef(null)
    const { orderItems } = useContext(OrderItemsContext)
    const { order, setOrder } = useContext(OrderDataContext)
    const { errors } = useContext(ErrorContext)
    const { menu } = useContext(MenuContext)
    const { translations } = useContext(TranslationContext)
    const [setReservedTimes] = useState([])

    useEffect(() => {
        if (errors?.time || errors?.location) {
            myRef.current.scrollIntoView()
        }
    }, [errors])

    const setComment = (value) => {
        setData('comment', value)
    }

    const setData = (key, value) => {
        setOrder({
            ...order,
            [key]: value,
        })
    }
    return (
        <Wrapper>
            <ContentHeader>
                <Heading page={page} />
                {Object.keys(orderItems).length > 0 ?
                    <Order>
                        {Object.keys(orderItems).map(key =>
                            <Item
                                key={key}
                                id={key}
                                quantity={orderItems[key].quantity}
                                items={menu}
                                children={orderItems[key].children
                            }/>
                        )}
                    </Order> : <Order>{translations.table_book_only}</Order>
                }
                <Form ref={myRef}>
                    <Textarea placeholder={translations.review_comment} value={order.comment} setValue={setComment} />
                </Form>
            </ContentHeader>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    flex: 1;
    flex-direction: column;
`

const Order = styled.div`
    background: #F4F4F4;
    border-radius: 10px;
    padding: 15px;
    margin-top: 40px;
    box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.19);
`

const Form = styled.div`
    margin-top: 20px;

    & > * {
        margin-bottom: 20px;
    }
`

export default ConfirmPage;
